import { render, staticRenderFns } from "./DuplicateNameConfirm.vue?vue&type=template&id=66fd968a&scoped=true&"
import script from "./DuplicateNameConfirm.vue?vue&type=script&lang=ts&"
export * from "./DuplicateNameConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateNameConfirm.vue?vue&type=style&index=0&id=66fd968a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd968a",
  null
  
)

export default component.exports